module.exports = __webpack_public_path__ + "static/media/cepid.d67fed45.jpg";